import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { BrokeNotificationMutationKeys } from '../../../keys'
import {
	UpdateBrokeNotificationRequest,
	UpdateBrokeNotificationResponse,
} from '../../../type'
import { updateBrokeNotification } from '../../services'

interface UseMutationUpdateBrokeNotificationProps {
	id: string
	payload: UpdateBrokeNotificationRequest
}

export default function useMutationUpdateBrokeNotification(
	props?: UseBaseMutationOptions<
		UpdateBrokeNotificationResponse,
		UseMutationUpdateBrokeNotificationProps
	>,
) {
	return useMutation({
		mutationKey: [BrokeNotificationMutationKeys.UpdateBrokeNotification],
		mutationFn: (params) => updateBrokeNotification(params.id, params.payload),
		...props,
	})
}
